<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -- We need to be able to modify this directly -->
<div [style.display]="state().value === 'inactive' ? 'none' : ''">
  @if (title) {
    <h6 class="text-lg font-semibold" [ngClass]="options.titleClass" [attr.aria-label]="title">{{ title }}</h6>
  }
  @if (message) {
    @if (options.enableHtml) {
      <div role="alert" [class]="options.messageClass" [innerHTML]="message"></div>
    } @else {
      <div role="alert" [class]="options.messageClass" [attr.aria-label]="message">{{ message }}</div>
    }
  }

  <button
    mat-icon-button
    mat-dialog-close
    class="toast-close-button !absolute right-2 top-1"
    aria-label="Close"
    (click)="remove()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
@if (options.progressBar) {
  <div>
    <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -- We have to be able to modify the width manually here -->
    <div class="toast-progress absolute bottom-0 left-0 h-1 bg-black/40" [style.width]="width() + '%'"></div>
  </div>
}
